module.exports = __webpack_public_path__ + "img/2187.d4a97f2f.gif";